import React, {useEffect} from 'react';
import Container from "@mui/material/Container";
import {useSelector} from "react-redux";
import PilotRegistrationList from "./PilotRegistrationList";
import {hasScope} from "../../hooks/useUserRole";
import {eventStatus} from "../../util/standards-util";
import PilotEntryList from "./PilotEntryList";
import PublicPilotRegistrationList from "./PublicPilotRegistrationList";

const Pilots = () => {
    const event = useSelector(state => state.session.event)
    const session = useSelector( state => state.session)
    const [hasEventManagerScope, setHasEventManagerScope] = React.useState(false)


    useEffect(() => {
        if (hasScope(session,'SERVICE_SGP_ADMIN') ||
            (
                session.services &&
                session.services.find(evt => evt.id === event.id) &&
                hasScope(session,['SERVICE_SGP_MANAGER','SERVICE_SGP_ADMIN','SERVICE_SGP_SCORER'])
            )
        ) {
            setHasEventManagerScope(true)
        }
    }, [session.services])


    return (
        <Container maxWidth={'lg'}>
            {event &&
                <>
                    {hasEventManagerScope && event && event.status >= eventStatus.STATUS_PLANNED_REGISTRATION_CLOSED &&
                        <PilotRegistrationList event={event} hasEventManagerScope={hasEventManagerScope}/>
                    }
                    {!hasEventManagerScope && event && event.status >= eventStatus.STATUS_PLANNED_REGISTRATION_CLOSED &&
                        <PublicPilotRegistrationList event={event}/>
                    }
                    {event && event.status < eventStatus.STATUS_PLANNED_REGISTRATION_CLOSED &&
                        <PilotEntryList event={event}  hasEventManagerScope={hasEventManagerScope}/>
                    }
                </>
            }
        </Container>
    )
}

export default Pilots